_ = require 'underscore'
React = require 'react'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
logError = require 'app/scripts/debug/log-error'
t = require('app/scripts/views/internal/recup-with-helpers')('onboarding')
{ trackUe } = require '@trello/analytics'
{ verticals } =  require 'app/scripts/views/onboarding/constants'
{ copyBoardFromVertical, getVertical, removeBoard, getLocale } =  require 'app/scripts/views/onboarding/helpers'
{ IconName } = require 'app/common/components/controls/icon'

module.exports = class InspirationPopover extends React.Component
  displayName: 'InspirationPopover'

  constructor: ->
    super

    locale = getLocale()

    formattedVerticals = Object.keys(verticals).map (vertical) => Object.assign(verticals[vertical], {
      key: vertical
    })
    [verticalsToSort, verticalsToShuffle] = _.partition(formattedVerticals, (d) -> !isNaN(d.sortId))
    @verticals = verticalsToSort
      .sort (a, b) => a.sortId - b.sortId
      .concat _.shuffle(verticalsToShuffle)
      .filter (vertical) => vertical.inspirationBoards[locale]

    @state = {
      copyingBoard: false
      selectedVertical: getVertical(@props.boardId)
    }

  componentWillReceiveProps: (nextProps) ->
    if nextProps.boardId != @props.boardId
      @setState({ selectedVertical: getVertical(nextProps.boardId) })

  handleChangeSelect: (e) ->
    vertical = e.target.value
    trackUe('Inspiration Board Popover', 'changes', 'vertical', '', '', '', {
      boardId: @props.boardId,
      lastVertical: @state.selectedVertical,
      nextVertical: vertical
    })
    @setState({ copyingBoard: true, selectedVertical: vertical }, =>
      copyBoardFromVertical(@props.modelCache, vertical)
        .then(=>
          @setState({ copyingBoard: false, })
        )
        .catch((err) =>
          logError(err, {
            vertical: vertical,
            message: 'Error copying board',
            feature: 'Personalized Onboarding',
            source: 'Inspiration Popover',
          })
          @setState({ copyingBoard: false, })
        )
    )

  handleKeepBoard: ->
    trackUe('Inspiration Board Popover', 'clicks', 'keep board', '', '', '', { boardId: @props.boardId, vertical: @state.selectedVertical })
    removeBoard(@props.boardId)
    @props.onClose()

  handleGetStarted: ->
    trackUe('Inspiration Board Popover', 'clicks', 'get started', '', '', '', { boardId: @props.boardId, vertical: @state.selectedVertical })
    v = if @state.selectedVertical == 'other' then  'default' else @state.selectedVertical
    Controller
      .navigate("/create-first-board?selectedVertical=#{v}", {
        trigger: true
      })

  render: t.renderable ->
    { copyingBoard, selectedVertical } = @state

    t.div '.inspiration-popover', =>
      t.div '.inspiration-popover--taco', =>
        t.div '.inspiration-popover--taco-inner', =>
          t.img {
            src: require('resources/images/taco.png')
          }
      t.div '.inspiration-popover--content', =>
        t.h2 =>
          t.format 'welcome-to-trello-wave', { name: Auth.me().get('fullName') }
        t.div '.inspiration-popover--select', =>
          if copyingBoard
            t.div '.spinner'
          t.icon IconName.Down
          t.select {
            onChange: (e) => @handleChangeSelect(e)
            defaultValue: selectedVertical
          }, =>
            for { key } in @verticals
              val =
                if key == selectedVertical
                  t.l ['exploring-trello-for'], { vertical: t.l key }, { raw: true }
                else
                  t.l key
              t.option '.inspiration-popover--select-option', {
                value: key
              }, =>
                t.text val
        t.p =>
          t.format 'heres-an-example-of-how-to-use', { vertical: t.l selectedVertical }
        t.p =>
          t.format 'this-is-just-an-example'
        t.button '.button.primary', {
          onClick: => @handleKeepBoard()
          disabled: copyingBoard
          class: t.classify({ 'disabled': copyingBoard })
        }, =>
          t.format 'keep-this-board'
        t.button '.button', {
          onClick: => @handleGetStarted()
          disabled: copyingBoard
          class: t.classify({ 'disabled': copyingBoard })
        }, =>
          t.format 'help-me-get-started'
